import React from "react";
import ReactDom from "react-dom";
import SearchPage from "./SearchPage.jsx";

export function renderSearch() {
  document.querySelectorAll(".js-search-mount").forEach((mount, i) => {
    const dictionary = JSON.parse(mount.dataset.dictionary) || null;
    const dataModel = JSON.parse(mount.dataset.model);

    ReactDom.render(
      <SearchPage dictionary={dictionary} id={`search-${i}`} {...dataModel} />,
      mount,
    );
  });
}
